let lgbt = [
    "bisexual man",
    "bisexuality",
    "black lgbt",
    "closeted homosexual",
    "drag queen",
    "female homosexuality",
    "gay  hardcore",
    "gay adoption",
    "gay artist",
    "gay bar",
    "gay club",
    "gay couple",
    "gay erotica",
    "gay for pay",
    "gay friend",
    "gay history",
    "gay interest",
    "gay kiss",
    "gay love",
    "gay love story",
    "gay man",
    "gay marriage",
    "gay men",
    "gay muslim",
    "gay parent",
    "gay pornography",
    "gay pride",
    "gay priest",
    "gay relationship",
    "gay rights",
    "gay romance",
    "gay sauna",
    "gay sex",
    "gay son",
    "gay teenager",
    "gay theme",
    "gay youth",
    "gender transition",
    "homoerotic",
    "homoeroticism",
    "homoerotism",
    "homofobia",
    "homophobia",
    "homophobic",
    "homophobic attack",
    "homosexual",
    "homosexual father",
    "homosexuality",
    "indigenous lgbt",
    "intersex",
    "intersexuality",
    "lesbian",
    "lesbian couple",
    "lesbian love",
    "lesbian maid",
    "lesbian nun",
    "lesbian relationship",
    "lesbian sex",
    "lgbt",
    "lgbt activist",
    "lgbt athlete",
    "lgbt history",
    "lgbt in africa",
    "lgbt in the military",
    "lgbt parenting",
    "lgbt rights",
    "lgbt teen",
    "male homosexuality",
    "queer",
    "queer cinema",
    "queer history",
    "queer loneliness",
    "queer love",
    "queer romance",
    "queer sexuality",
    "repressed gay",
    "teenage lesbian romance",
    "trans man",
    "trans woman",
    "transgender",
    "transgender rights",
    "transition",
    "transsexual",
    "transsexuality",
    "transvestism",
    "transvestite",
    "boys' love",
    "boys love"
]

let adult = [
    'porn',
    'sex',
    'xxx',
    'erotic',
    'fetish',
    'bdsm',
    'bondage',
    'sado',
    'masochism',
    'voyeurism',
    'exhibitionism',
    'incest',
    'softcore',
    'eroticism',
    'erotica',
    'nude',
    'nudity',
    'nudism',
    'naked',
    'pink film',
]

let filter = [
    'путин',
    'россия',
    'putin',
    'russia',
    'лукашенко',
    'lukashenko',
    'навальный',
    'navalny',
    '^буча',
    'мариуполь',
    'гомосекс',
	'homosex',
    'кремль'
]

export default {
    lgbt,
    adult,
    filter
}